import { render, staticRenderFns } from "./agencyItem.vue?vue&type=template&id=4a9ef5c2&scoped=true&"
import script from "./agencyItem.vue?vue&type=script&lang=js&"
export * from "./agencyItem.vue?vue&type=script&lang=js&"
import style0 from "./agencyItem.vue?vue&type=style&index=0&id=4a9ef5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9ef5c2",
  null
  
)

export default component.exports